import React, { useEffect, useState } from 'react'
import ActionArea from '../../components/ActionArea'
import SmartSearch from '../../components/UI/SmartSearch'

interface searchBarProps {
  getItems: (type?: string, id?: string, payload?: any) => void

}

function SearchBar(props: searchBarProps) {

  const [search, setSearch] = useState({
    text: '',
    params: {
      id: '',
      name: '',
      type: '',
    }
  });

  const [validSearch, setValidSearch] = useState(false)


  /*const handleEnter = (event: KeyboardEvent) => {
    if (!event.repeat && event.key === 'Enter') {
      props.getItems(search.params.type, search.params.id, search)
    }
  }

  useEffect(() => {
    document.addEventListener("keydown", handleEnter)
    return () => document.removeEventListener("keydown", handleEnter)
  })
*/
  return (
    <>
      <ActionArea 
        buttonAction={() => props.getItems(search.params.type, search.params.id, search)}
        buttonText={'Refresh'}
        disabled={!validSearch}
      >
        <SmartSearch
          status='active'
          value={search.text}
          onChange={(e: string) => setSearch({ ...search, text: e })}
          onValidSearch={setValidSearch}
          label='Smart Search'
          searchBy={['location']}
          onObjValueChange={(e: any) => setSearch({ ...search, params: e })}
          autoFocus
        />
      </ActionArea>
    </>
  )
}

export default SearchBar
